module.exports = __webpack_public_path__ + "img/stuck_out_tongue_winking_eye.849221cf.png";